import { InjectionToken } from '@angular/core';

export const FSServiceToken = new InjectionToken<IFileSystemService>(
  'FileSystemService',
);

export interface IFileSystemService {
  exportAsExcelFile(fileName: string, json: any[]): void;
}
